import React from 'react';
import { safeHtml, decodeEntities } from '../../../utils/safeHtml';

const Footnotes = ({ footnotes, paginatedData }) => {
    if (!footnotes || !paginatedData || footnotes.length === 0 || paginatedData.length === 0) return null;
    // Get unique statuses from current page
    const pageStatuses = [...new Set(paginatedData.map(clinic => clinic.ClinicStatus))];

    // If footnotes exist in the API response and we have matching statuses on the page, show them
    const hasFootnoteableStatus = pageStatuses.length > 1;  // More than just "Open"

    if (!hasFootnoteableStatus) return null;
    // Function to determine class based on symbol character code.
    // Symbols arrive encoded (e.g. "&amp;#x2020;"), so decode before reading the char code.
    const getFootnoteClass = (symbol) => {
        const decoded = decodeEntities(symbol);
        if (!decoded) return '';
        const charCode = decoded.charCodeAt(0);

        switch (charCode) {
            case 8224: // �
                return 'clinicStatusBottomNone';
            case 163:  // �
                return 'clinicStatusBottomReorganized';
            case 167:  // �
                return 'clinicStatusBottomClosed';
            default:
                return '';
        }
    };
    return (
        <div className="footnotes-section col mt-2">
            <div className="footnotes">
                {footnotes
                    .sort((a, b) => parseInt(a.OrderBy) - parseInt(b.OrderBy))
                    .map((footnote, index) => {
                        const footnoteClass = getFootnoteClass(footnote.Symbol);
                        return (
                            <p key={index} className="mb-2">
                                <span
                                    className={`footnote-symbol ${footnoteClass}`}
                                    dangerouslySetInnerHTML={{ __html: safeHtml(footnote.Symbol) }}
                                />
                                <span
                                    className="footnote-text ms-2"
                                    dangerouslySetInnerHTML={{ __html: safeHtml(footnote.FootNote) }}
                                />
                            </p>
                        );
                    })}
            </div>
        </div>
    );
};
export default Footnotes;